/* Product page star rating review */
$('.commentlist .review').each(function () {
    var starRating = $(this).find('.star-rating .rating');
    var starRatingWrap = $(this).find('.star-rating');
    let starRatingValue = starRating.text(); // find value
    let starRatingInt = parseInt(starRatingValue); // convert to number
    let starRatingRound = Math.round(starRatingInt); // round up to whole

    if (starRatingRound === 1) {
        starRatingWrap.addClass('__one');
    }

    if (starRatingRound === 2) {
        starRatingWrap.addClass('__two');
    }

    if (starRatingRound === 3) {
        starRatingWrap.addClass('__three');
    }

    if (starRatingRound === 4) {
        starRatingWrap.addClass('__four');
    }

    if (starRatingRound === 5) {
        starRatingWrap.addClass('__five');
    }
});


/**
 * Quantity increment/decrement functions.
 */
$('.quantityPlus').on('click', function () {
    let qty = $(this).siblings('.qty');
    let max = parseInt(qty.attr('max'));
    let val = parseInt(qty.val());

    if (Number.isInteger(max)) {
        val = Math.min(max, val + 1);
    } else {
        val = val + 1;
    }

    qty.val(val).trigger('change');
});

$('.quantityMinus').on('click', function () {
    let qty = $(this).siblings('.qty');
    let val = parseInt(qty.val());
    if (val > 1) {
        qty.val(val - 1).trigger('change');
    }
});


/**
 * Logged in / logged out user
 */
$(document).ready(function () {
    // var banner = $('section.banner')
    var loggedIn = $('body').hasClass('logged-in');

    // used to add a class to the account wrapper
    if ((window.location.href.indexOf("my-account") > -1) && (loggedIn)) {
        $('.woocommerce').addClass('my-account-container');
        $('.page').addClass('woocommerce-account-wrapper');
    }

    if ((window.location.href.indexOf("my-account/edit-address/billing") > -1 || window.location.href.indexOf("my-account/edit-address/shipping") > -1) && (loggedIn)) {
        $('.woocommerce-MyAccount-content').addClass('__address-form-active');
        $('.woocommerce-MyAccount-content form').prepend('<div class=\"backto\"><span class=\"icon icon-arrow-set4-left"></span><a href=\"/my-account/edit-address\">Back to address</a></div>');
    }
});


/* Checkboxes */
$(document).on('change', '.wc-block-components-checkbox input', function () {
    if ($(this).is(':checked')) {
        $(this).parent('label').parent('.wc-block-components-checkbox').addClass('__checked');
    } else {
        $(this).parent('label').parent('.wc-block-components-checkbox').removeClass('__checked');
    }
});
$('.wc-block-components-checkbox input:checked')
    .parent('label').parent('.wc-block-components-checkbox').addClass('__checked');

/* Reviews tab consent checkbox */
$(document).ready(function () {
    // Check initial state on page load
    $('.comment-form-cookies-consent input').each(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('label').addClass('__checked');
        }
    });

    // Add event listener for changes in checkbox state
    $('.comment-form-cookies-consent input').change(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('label').addClass('__checked');
        } else {
            $(this).siblings('label').removeClass('__checked');
        }
    });
});

/* Add class to /my-account address if no address has been added */
$(document).ready(function () {
    $(".woocommerce-Address header a.edit:contains('Add')").closest('.woocommerce-Address').addClass("__noaddress");
    $(".woocommerce-Address.u-column1 header a.edit:contains('Add')").text("Add billing details");
    $(".woocommerce-Address.u-column2 header a.edit:contains('Add')").text("Add shipping details");
});

// Open and close filters on product archive
$('.productFilter').each(function (i, filter) {
    var productFilter = $(this);
    var filterButton = '.filterButton';
    var filterInput = '.filterInput';
    var filterParent = '.filterParent';
    var filterResults = $('.product-archive .products, .search-listing .search-list, .publication-listing .publication-list');
    var findFilterButton = productFilter.find(filterButton);
    var findFilterInput = productFilter.find(filterInput);
    var body = $('body');
    var break_point = 992; // large breakpoint
    var browser_width = window.innerWidth;

    findFilterButton.click(function (e) {
        var filterHeight = $('.filterWrap > form').height();
        event.preventDefault();
        
        if ($(this).attr('aria-expanded') === 'true') {
            $(this).attr('aria-expanded', false);
            $(this).removeClass('__active');
            productFilter.parent().removeClass('__active');
            findFilterInput.slideUp(function () {
                var filterHeight = $('.filterWrap > form').outerHeight();
                filterResults.css('min-height', filterHeight + 500);
            });
            findFilterInput.attr('aria-hidden', true);
            body.removeClass('__filters-active');

            if ($(browser_width < break_point)) {
                findFilterInput.slideUp(function () {
                    filterResults.css('min-height', 'unset');
                });
            }
        }

        else {
            $(this).attr('aria-expanded', true);
            $(this).addClass('__active');
            productFilter.parent().addClass('__active');
            findFilterInput.slideDown(function () {
                var filterHeight = $('.filterWrap > form').outerHeight();  // Recalculate after slide down
                filterResults.css('min-height', filterHeight + 500);
            });
            findFilterInput.attr('aria-hidden', false);
            $(this).closest(filterParent).siblings().find(filterButton).attr('aria-expanded', false);
            $(this).closest(filterParent).siblings().find('.__active').removeClass('__active');
            $(this).closest(filterParent).siblings().find(filterInput).slideUp().attr('aria-hidden', true);
            body.addClass('__filters-active');
        }
    });

    $(window).on("load", function () {
        if ((filterResults.length > 0) && (browser_width >= break_point)) {
            var filterHeight = $('.filterWrap > form').height();
            filterResults.css('min-height', filterHeight + 500);
        };
    })
});

$('.wc-block-mini-cart__button').click(event, function() {
    if ($(this).attr('aria-expanded', 'false')) {
        $(this).attr('aria-expanded', 'true');
        $('body').addClass('__cart-active');
        $('.wc-block-components-drawer__screen-overlay').show();
        $('.wc-block-components-drawer__screen-overlay').addClass('wc-block-components-drawer__screen-overlay--with-slide-out');
        $('.wc-block-components-drawer__screen-overlay').removeClass('wc-block-components-drawer__screen-overlay--with-slide-in');
        $('.wc-block-components-drawer .wc-block-components-drawer__close').focus();

        
    }
})

$('.wc-block-components-drawer__close').click(event, function () {
    $('.wc-block-mini-cart__button').attr('aria-expanded', 'false');
    $('body').removeClass('__cart-active');
    $('.wc-block-components-drawer__screen-overlay').hide();
    $('.wc-block-components-drawer__screen-overlay').addClass('wc-block-components-drawer__screen-overlay--with-slide-in');
    $('.wc-block-components-drawer__screen-overlay').removeClass('wc-block-components-drawer__screen-overlay--with-slide-out');
    $('.wc-block-mini-cart__button').focus();
});


$('.woocommerce-mini-cart__buttons .button.wc-forward:not(.checkout').addClass('__outline');